export class GetItem {
  static readonly type = '[XuiPage] Get Item';
  constructor(public entityName: string, public id: string) {}
}
